/* libs/oyan-ui/src/lib/features/admin/components/user-profile-info/user-profile-info.component.scss */
.user-profile-info-container {
  font-size: 12px;
}
.user-profile-info-section-title {
  font-size: 18px;
  font-weight: 600;
  white-space: nowrap;
  padding-bottom: 20px;
}
.user-profile-info-name {
  font-size: 16px;
  padding-bottom: 10px;
}
.user-profile-info-status-container {
  padding-top: 10px;
}
.user-profile-info-status {
  font-weight: 600;
}
/*# sourceMappingURL=user-profile-info.component.css.map */
